var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"page-index pc"},[_c('home-section1'),_c('home-section2'),_c('home-section3'),_c('home-section4'),_c('home-section5'),_c('home-section6')],1),_c('div',{staticClass:"page-index mobile"},[_c('home-section1m'),_c('home-section2m'),_c('home-section3m'),_c('home-section4m'),_c('home-section5m'),_c('home-section6m')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }